<template>
<div id="regist">
    <div id="policy-content">
        <div class="btn-close" @click="close_layer">
            <span class="bar"></span>
            <span class="bar"></span>
        </div>
        <!-- <iframe src="http://devgroup.co.kr/privacy/policy.php" frameborder="0"></iframe> -->
        <iframe src="https://readingroom.momu24.com/apps/solution_app_policy.php" frameborder="0"></iframe>
    </div>
    <div id="main">
        <div id="wrap join-wrap" style="overflow: scroll;">
            <div id="header">
                <div class="header-wrap">
                    <div class="top-menu-bar">
                        <div class="back" @click="go_login()">
                            <a href="#">
                                <img src="../../assets/images/back.png" alt="icon-menu">
                            </a>
                        </div>
                        <h1 class="page-title">
                            <a>
                                <span>회원가입</span>
                            </a>
                        </h1>
                        <!-- <div class="mypage">
                            <a href="#">

                            </a>
                        </div> -->
                        <div class="bottom-radius"></div>
                    </div>
                </div>
            </div>
            <div id="join">
                <div class="input-join">
                    <div class="regi-title"><span style="color: red;">*</span> 필수입력사항</div>
                    <div class="join-content">
                        <h3 class="join-title"><label for="user_name">이름<span style="color:red">*</span></label></h3>
                        <input type="text" id="user_name" name="user_name" v-model="name">
                        <p v-if="name.length == 0" class="warn-text" style="color:red">이름을 입력해주세요.</p>
                    </div>

                    <div class="join-content">
                        <h3 class="join-title"><label for="user_m_account_id">아이디<span style="color:red">*</span></label></h3>
                        <div>
                            <!-- 2021-01-14 코드수정 및 추가 -->
                            <input type="text" id="user_m_account_id" name="user_m_account_id" v-model="user_m_account_id" maxlength="15" placeholder="아이디 4글자 이상">
                            <div class="btn-ok btn-confirm" @click="id_chk"><span>중복 확인</span></div>
                        </div>
                            <p v-if="status_id == true" class="warn-text" style="color:green">사용가능</p>
                            <p v-if="status_id == false" class="warn-text" style="color:red">사용불가능</p>
                    </div>

                    <div class="join-content">
                        <h3 class="join-title"><label for="user_hp">휴대폰번호<span style="color:red">*</span></label></h3>
                        <div>
                            <input type="text" name="user_hp" v-on:input="autoHyphen" placeholder="휴대폰번호" v-bind:value="user_hp" :readonly="auth_flag">
                            <div class="btn-ok btn-confirm"  @click="next_step"><span>인증번호 요청</span></div>                            
                        </div>
                        <!-- 2021-01-14 코드수정 및 추가 -->                        
                        <p v-if="status_hp == false" class="warn-text" style="color:red">휴대전화번호 10자리 또는 11자리를 정확히 입력해주세요.</p>
                    </div>

                    <div class="join-content" v-if="auth_step">
                        <h3 class="join-title"><label for="user_hp">인증번호</label></h3>
                        <div>
                            <input type="text" id="auth_num" name="auth_num" v-model="auth_num">
                            <div class="btn-ok btn-confirm"  @click="auth_chk" v-if="auth_num.length > 0"><span>인증번호 확인</span></div>
                            <div class="btn-noauth btn-confirm"  v-if="auth_num.length == 0"><span>인증번호 확인</span></div>                                                        
                        </div>
                        <p v-if="auth_flag == false" class="warn-text" style="color:red">인증번호를 확인해주세요.</p>
                        
                    </div>

                    <div class="join-content">
                        <h3 class="join-title"><label for="user_password">비밀번호<span style="color:red">*</span></label></h3>
                        <input type="password" id="user_password" name="user_password" v-model="password">
                        <!-- 2021-01-14 코드수정 및 추가 --> 
                        <p v-if="password.length < 8" class="warn-text" style="color:red">비밀번호 8자리이상 영문+숫자</p>
                    </div>
                    <div class="join-content">
                        <h3 class="join-title"><label for="password_confirm">비밀번호 확인<span style="color:red">*</span></label></h3>
                        <input type="password" id="password_confirm" name="password_confirm" v-model="password_chk">
                        <p v-if="password != password_chk" class="warn-text" style="color:red">비밀번호가 일치하지 않습니다.</p>
                    </div>

                    <div class="join-content">
                        <h3 class="join-title"><label for="parents_number">부모님 휴대폰번호</label></h3>
                        <input type="text" id="parents_number" name="parents_number" v-on:input="autoHyphen_parent" placeholder="휴대폰번호" v-bind:value="parents_hp">
                    </div>

                    <!-- <div class="join-content">
                        <h3 class="join-title"><label for="address">주소</label></h3>
                        <input type="text" id="address" name="address" placeholder="주소" v-model="address">
                    </div> -->
                    
                    <div class="join-content">
                        <h3 class="join-title"><label for="address">주소</label></h3>
                        <div>
                            <input type="text" id="address" name="address" v-model="address" maxlength="0" readonly>
                            <div class="btn-ok btn-confirm"  @click="searchAddress"><span>주소찾기</span></div>                            
                        </div>                        
                        <!-- <p v-if="status_hp == false" class="warn-text" style="color:red">휴대전화번호 11자리를 정확히 입력해주세요.</p> -->
                    </div>

                     <div class="join-content">
                        <h3 class="join-title"><label for="address_detail">상세주소</label></h3>
                        <input type="text" id="address_detail" name="address_detail" placeholder="상세주소" v-model="address_detail">
                    </div>
                    

                    <div class="join-content">
                        <h3 class="join-title"><label for="sex">성별</label></h3>
                        <div class="gender-input">
                            <input type="radio" name="sex_male" id="sex_male" value="male" v-model="gender">
                            <label for="gender_check">남</label>
                            <input type="radio" name="sex_female" id="sex_female" value="female" v-model="gender">
                            <label for="gender_check">여</label>
                        </div>
                    </div>
                    <div class="join-content">
                        <h3 class="join-title"><label for="birth">생년월일</label></h3>
                        <input type="text" id="birth" name="birth" v-model="birth" placeholder="ex) 19990101" maxlength="8">
                    </div>
                    <!-- 2021-01-14 코드수정 및 추가 --> 
                    <!-- <div class="join-content">
                        <h3 class="join-title"><label for="purpose">가입목적</label></h3>
                        <input type="text" id="purpose" name="purpose" placeholder="가입목적" v-model="purpose">
                    </div> -->
                    <!-- 코드 추가 - 2020-12-21 -->
                    <div class="join-content join-check">
                        <input type="checkbox" name="check" id="privacy_check" v-model="agree_yn">
                        <label for="privacy_check">개인정보 취급 방침 동의(필수)</label>
                        <span @click="open_layer" class="policy">내용 확인</span>
                    </div>
                    <p v-if="!agree_yn" class="warn-text agree-text" style="color:red">개인정보 취급방침에 동의해주세요.</p>
                    <!-- 코드 추가 - 2020-12-21 -->
                    <div class="join-content join-check">
                        <input type="checkbox" name="check_event" id="privacy_check_event" v-model="agree_yn_event">
                        <label for="privacy_check_event">이벤트 알림 동의(선택)</label>
                    </div>
                    
                </div>
                
                <div class="btn-wrap btn-form-join">
                    <div class="btn-noauth btn-join" v-if="name.length == 0 || auth_flag == false || status_id == false || status_hp == false || agree_yn == false || password != password_chk || status_id==null || password.length == 0"><span>회원가입</span></div>
                    <div class="btn-ok btn-join" v-if="name.length > 0 && auth_flag == true && status_id == true && status_hp == true && agree_yn == true && password == password_chk && password.length > 0" @click="regist_user()"><span>회원가입</span></div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as config from '../../js/config';
import common from '../../js/common';
import EventBus from '../../js/event_bus';
export default {
    name: 'regist',
    components: {},
    data() {
        return {
            name: '',
            user_m_account_id: '',
            user_hp: '010',
            password: '',
            password_chk: '',
            parents_hp: '010',
            gender: '',
            birth: null,
            purpose: '',
            address: '',
            address_detail:'',
            agree_yn: false,
            agree_yn_event: false,
            auth_step: false,
            auth_num: '',
            auth_flag: false,            
            //경고라인 관련
            status_id: null,
            status_hp:null,
            status_agree_yn:null
        }
    },
    mounted() {
        this.$nextTick(function () {

        });

    },
    methods: {
        id_chk(){
            if(this.user_m_account_id.length == 0){
                this.status_id = false;
                return;
            }
            if(this.user_m_account_id.length < 4) {
                var data = {
                    code: 103,
                    message: '아이디는 4글자 이상입니다.'
                };
                EventBus.$emit('popup-data', data);
                this.status_id = false;
                return;
            }
     
            var data = {
                user_m_account_id: this.user_m_account_id
            }
            var type = config.REQ_CHECK_USER_ID;
            common.getData(type, data,
                (response) => {
                    
                    if (response.result) {
                        this.status_id = true;
                    }else{
                        this.status_id = false;
                    }
                })
        },
        go_login() {
            this.$router.push('/login');
        },
        autoHyphen(e) {
            this.user_hp = e.target.value;
            var num = /^[0-9 \-]*$/;
            if (!num.test(this.user_hp)) {
                var str = this.user_hp;
                str = str.substr(0, str.length - 1);
                this.user_hp = str;
            }

            if (this.user_hp.length > 13) {
                this.user_hp = this.user_hp.substr(0, 13);
            } else {
                var val = this.user_hp.replace(/\D/g, '');
                var original = this.user_hp.replace(/\D/g, '').length;
                var conversion = '';
                for (let i = 0; i < 3; i++) {
                    if (val.length > 3 && i === 0) {
                        conversion += val.substr(0, 3) + '-';
                        val = val.substr(3);
                    } else if (original > 6 && val.length > 3 && i === 1) {
                        conversion += val.substr(0, 3) + '-';
                        val = val.substr(3);
                    } else if (original > 10 && val.length < 12 && i === 2) {
                        let value = this.user_hp.replace(/-/gi, "");
                        conversion = '';
                        this.user_hp = value.substring(0, 3) + '-' + value.substring(3, 7) + '-' + value.substring(7, 11);
                        return this.user_hp;
                    }
                }
                conversion += val;
                this.user_hp = conversion;
            }
        },
        autoHyphen_parent(e) {
            this.parents_hp = e.target.value;
            var num = /^[0-9 \-]*$/;
            if (!num.test(this.parents_hp)) {
                var str = this.parents_hp;
                str = str.substr(0, str.length - 1);
                this.parents_hp = str;
            }

            if (this.parents_hp.length > 13) {
                this.parents_hp = this.parents_hp.substr(0, 13);
            } else {
                var val = this.parents_hp.replace(/\D/g, '');
                var original = this.parents_hp.replace(/\D/g, '').length;
                var conversion = '';
                for (let i = 0; i < 3; i++) {
                    if (val.length > 3 && i === 0) {
                        conversion += val.substr(0, 3) + '-';
                        val = val.substr(3);
                    } else if (original > 6 && val.length > 3 && i === 1) {
                        conversion += val.substr(0, 3) + '-';
                        val = val.substr(3);
                    } else if (original > 10 && val.length < 12 && i === 2) {
                        let value = this.parents_hp.replace(/-/gi, "");
                        conversion = '';
                        this.parents_hp = value.substring(0, 3) + '-' + value.substring(3, 7) + '-' + value.substring(7, 11);
                        return this.parents_hp;
                    }
                }
                conversion += val;
                this.parents_hp = conversion;
            }
        },

        regist_user() {
            this.$store.commit('setLoading', { value: true });
            var gender;
            var agree_yn_event;
            if (this.gender == 'male') {
                gender = 0;
            } else if (this.gender == 'female') {
                gender = 1;
            }else{
                gender = 2;
            }
            if (this.agree_yn_event == false) {
                agree_yn_event = 0;
            } else {
                agree_yn_event = 1;
            }
            if (this.birth != null) {
                if (this.birth.length == 0) {
                    this.birth = 0;
                }

            }
            var num = this.password.search(/[0-9]/g);
            var eng = this.password.search(/[a-z]/ig);
            var spe = this.password.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi);
            // 2021-01-14 코드수정 및 추가
            // 추가로 해당영역에서 현재 알러트 창 띄워주고있습니다.
            // 테마에 맞는 팝업창 제작후 팝업창으로 띄워주는 추가작업이 필요합니다
            if (this.password.search(/\s/) != -1) {
                var data = {
                    code: 103,
                    message: '비밀번호는 공백 없이 입력해주세요.'
                };
                EventBus.$emit('popup-data', data);
                this.$store.commit('setLoading', { value: false });
                return 
            } else if ((num < 0 || eng < 0)) {
                var data = {
                    code: 103,
                    message: '영문,숫자 중 2가지 이상을 혼합하여 입력해주세요'
                };
                EventBus.$emit('popup-data', data);
                this.$store.commit('setLoading', { value: false });
                return 
            } 


            var data = {
                name: this.name,
                user_m_account_id: this.user_m_account_id,
                user_hp: this.user_hp,
                parents_hp: this.parents_hp,
                agree_yn: this.agree_yn,
                password: this.password,
                gender: gender,
                birth: this.birth,
                purpose: this.purpose,
                address: this.address,
                address_detail:this.address_detail,
                agree_yn_event: agree_yn_event
            }

            var type = config.REQ_USER_REGIST;
            common.getData(type, data,
                (response) => {
                    let data = {
                        code: 103,
                        message: response.message
                    };
                    EventBus.$emit('popup-data', data);
                    if (response.result) {
                        this.$router.push('/login');
                    } 

                })

        },
        next_step() {
            this.auth_num = '';
            this.auth_flag = false;
            // 2021-01-14 코드수정 및 추가
            if (this.user_hp.length < 12) {
                this.status_hp = false;
                return;
            }
            
            var data = {
                user_hp: this.user_hp,
                store_tel_number: '1811-8684',
                store_id: 'join_msg'
            }
            var type = config.REQ_AUTH;
            common.getData(type, data,
                (response) => {
                    if (response.result) {
                        var data = {
                            code: 103,
                            message: '입력하신 번호로 인증번호를 전송했습니다. <br> 5분 이내에 인증번호를 입력해주세요.'
                        };
                        EventBus.$emit('popup-data', data);
                        this.status_hp = true;
                        this.auth_step = true;
                    }
                })
            
        },
        auth_chk() {
            if(this.auth_flag == true){
                return;
            }
            var data = {
                auth_num: this.auth_num,
                user_hp: this.user_hp
            }

            var type = config.REQ_CHECK_AUTH;
            common.getData(type, data,
                (response) => {
                    if (response.result) {
                        var data = {
                            code: 103,
                            message: '인증되었습니다.'
                        };
                        EventBus.$emit('popup-data', data);
                        this.auth_flag = true;
                    } else {
                        if (response.result_txt == "time_over") {
                            var data = {
                                user_hp: this.user_hp,
                                m_auth_use_id: response.m_auth_use_id
                            }
                            var type = config.REQ_RE_AUTH;
                            common.getData(type, data,
                                (response) => {
                                    if (response.result) {
                                        var data = {
                                            code: 103,
                                            message: '시간이 경과되었습니다.<br> 입력하신 번호로 인증번호를 재전송했습니다. <br> 5분 이내에 인증번호를 입력해주세요.'
                                        };
                                        EventBus.$emit('popup-data', data);

                                        this.auth_num = '';
                                    }
                                })
                        } else if (response.result_txt == "number_err") {
                            var data = {
                                code: 103,
                                message: '인증번호가 올바르지 않습니다.'
                            };
                            EventBus.$emit('popup-data', data);
                        }
                        this.auth_flag = false;

                    }
                })
        },
        searchAddress(){
            var self = this;
            var callback = function(result){
                self.address = result.address;
            };
            // common.searchAddressView(callback);
            getSearchAddress(callback);
        },
        open_layer() {
            document.getElementById('policy-content').classList.add('on');
        },
        close_layer() {
            document.getElementById('policy-content').classList.remove('on');
        },
    },
    watch: {
        // 2021-01-14 코드수정 및 추가
        user_m_account_id(val) {

            this.status_id = null;
            const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
            if (this.user_m_account_id.length == 1) {
                const regs = /[0-9]/;
                this.user_m_account_id = this.user_m_account_id.replace(regs, '');
            }

            const reg2 = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;
            this.user_m_account_id = this.user_m_account_id.replace(reg2, '');
            if (reg.exec(val) !== null) {
                this.user_m_account_id = this.user_m_account_id.slice(0, -1);
                return this.user_m_account_id = this.user_m_account_id.replace(/[^a-z0-9]/gi, '')
            }
        },
        birth(val) {
            var reg = /^[0-9 \-]*$/;
            if (!reg.test(this.birth)) {
                var str = this.birth;
                str = str.substr(0, str.length - 1);
                this.birth = str;
            }
        },
        // 2021-01-14 코드수정 및 추가
        name(val) {
            const reg = /[0-9]/;
            const reg2 = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;
            this.name = this.name.replace(reg2, '');
            if (reg.exec(val) !== null) {
                this.name = this.name.slice(0, -1);
                return this.name = this.name.replace(/[^a-z0-9]/gi, '')
            }
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/RegistPage.vue